<template>
    <div>
        <rkm-modal
            extra-large
            ref="RkmModal"
            title="Medicamentos em uso"
        >
            <rkm-area
                background-color="primary"
                title="Medicamentos em uso"
                type="box"
            >
                <rkm-list
                    :items="medicamentosEmUso"
                    hide-filters
                    hide-pagination
                    item-cursor="default"
                >
                    <template v-slot="{item}">
                        <rkm-row>
                            <rkm-col cols="3">
                                <strong>Medicamento</strong><br/>{{item.materialDescricao}}
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Via de administração</strong><br/>{{item.materialViaAdministracao}}
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Posologia</strong><br/>{{item.posologia}}
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Dose única</strong><br/>{{item.isDoseUnica ? 'Sim' : 'Não'}}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="3">
                                <strong>Uso contínuo</strong><br/>{{item.isUsoContinuo ? 'Sim' : 'Não'}}
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Início do tratamento</strong><br/>{{item.inicio}}
                            </rkm-col>

                            <rkm-col
                                v-if="!item.isUsoContinuo"
                                cols="3"
                            >
                                <strong>Duração</strong><br/>{{item.duracao}}
                            </rkm-col>

                            <rkm-col
                                v-if="item.conclusao"
                                cols="3"
                            >
                                <strong>Conclusão do tratamento</strong><br/>{{item.conclusao}}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <strong>Recomendações</strong><br/>{{item.recomendacoes || '&nbsp;'}}
                            </rkm-col>
                        </rkm-row>

                        <template v-if="item.isTratamentoInterrompido">
                            <rkm-row>
                                <rkm-col cols="3">
                                    <strong>Tratamento interrompido</strong><br/>{{item.tratamentoInterrompidoEm}}
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <strong>Justificativa do tratamento interrompido</strong><br/>{{item.tratamentoInterrompidoJustificativa}}
                                </rkm-col>
                            </rkm-row>
                        </template>
                    </template>

                    <template v-slot:trailling="{item}">
                        <rkm-button
                            v-if="data.model.medicamentosEmUso.medicamentosComTratamentoInterrompido.find(medicamentoComTratamentoInterrompido => medicamentoComTratamentoInterrompido.prescricaoMedicamentoItemId === item.id)"
                            @click="destroy(item)"
                            color="primary"
                            small
                            title="Cancelar interrupção"
                        >
                            <rkm-icon icon="undo" />
                        </rkm-button>

                        <rkm-button
                            v-else
                            @click="$refs.ModalJustificativaInterrupcaoTratamento.open(item)"
                            color="warning"
                            small
                            title="Interromper tratamento"
                        >
                            <rkm-icon icon="ban" />
                        </rkm-button>
                    </template>
                </rkm-list>
            </rkm-area>

            <rkm-area
                background-color="primary"
                closed
                title="Medicamentos com tratamento concluído"
                type="box"
            >
                <rkm-list
                    :items="medicamentosComTratamentoConcluido"
                    hide-filters
                    hide-pagination
                    item-cursor="default"
                >
                    <template v-slot="{item}">
                        <rkm-row>
                            <rkm-col cols="3">
                                <strong>Medicamento</strong><br/>{{item.materialDescricao}}
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Via de administração</strong><br/>{{item.materialViaAdministracao}}
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Posologia</strong><br/>{{item.posologia}}
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Dose única</strong><br/>{{item.isDoseUnica ? 'Sim' : 'Não'}}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="3">
                                <strong>Uso contínuo</strong><br/>{{item.isUsoContinuo ? 'Sim' : 'Não'}}
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Início do tratamento</strong><br/>{{item.inicio}}
                            </rkm-col>

                            <rkm-col
                                v-if="!item.isUsoContinuo"
                                cols="3"
                            >
                                <strong>Duração</strong><br/>{{item.duracao}}
                            </rkm-col>

                            <rkm-col
                                v-if="item.conclusao"
                                cols="3"
                            >
                                <strong>Conclusão do tratamento</strong><br/>{{item.conclusao}}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <strong>Recomendações</strong><br/>{{item.recomendacoes || '&nbsp;'}}
                            </rkm-col>
                        </rkm-row>

                        <template v-if="item.isTratamentoInterrompido">
                            <rkm-row>
                                <rkm-col cols="3">
                                    <strong>Tratamento interrompido</strong><br/>{{item.tratamentoInterrompidoEm}}
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <strong>Justificativa do tratamento interrompido</strong><br/>{{item.tratamentoInterrompidoJustificativa}}
                                </rkm-col>
                            </rkm-row>
                        </template>
                    </template>
                </rkm-list>
            </rkm-area>

            <BoxPrescricaoMedicamento
                :data="{additionals: data.additionals, form: data.form.plano, model: data.model.plano}"
                readonly
            />

            <template v-slot:footer="{cancel}">
                <rkm-button @click="cancel">
                    Fechar
                </rkm-button>
            </template>
        </rkm-modal>

        <ModalJustificativaInterrupcaoTratamento
            :data="data"
            ref="ModalJustificativaInterrupcaoTratamento"
        />
    </div>
</template>

<script>
// Components.
import BoxPrescricaoMedicamento from '@/components/ambulatorio/atendimento/components/soap/components/plano/components/prescricao-medicamento/Index'
import ModalJustificativaInterrupcaoTratamento from './components/justificativa-interrupcao-tratamento/Modal'

export default {
    components: {
        BoxPrescricaoMedicamento,
        ModalJustificativaInterrupcaoTratamento,
    },
    computed: {
        medicamentosEmUso() {
            const medicamentos = []

            this.data.form.plano.prescricoesMedicamentos.forEach(function (prescricaoMedicamento) {
                prescricaoMedicamento.medicamentos
                    .filter(function (medicamento) {
                        return !medicamento.isManual && !medicamento.isTratamentoInterrompido && !medicamento.isTratamentoConcluido
                    })
                    .forEach(function (medicamento) {
                        medicamentos.push(medicamento)
                    })
            })

            return medicamentos
        },
        medicamentosComTratamentoConcluido() {
            const medicamentos = []

            this.data.form.plano.prescricoesMedicamentos.forEach(function (prescricaoMedicamento) {
                prescricaoMedicamento.medicamentos
                    .filter(function (medicamento) {
                        return !medicamento.isManual && (medicamento.isTratamentoInterrompido || medicamento.isTratamentoConcluido)
                    })
                    .forEach(function (medicamento) {
                        medicamentos.push(medicamento)
                    })
            })

            return medicamentos
        },
    },
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
        destroy(item) {
            this.showDeleteConfirmation('Deseja realmente cancelar a interrupção do tratamento?', async () => {
                const index = this.data.model.medicamentosEmUso.medicamentosComTratamentoInterrompido.findIndex(medicamentoComTratamentoInterrompido => medicamentoComTratamentoInterrompido.prescricaoMedicamentoItemId === item.id)

                this.data.model.medicamentosEmUso.medicamentosComTratamentoInterrompido.splice(index, 1)
            })
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>